import * as Yup from 'yup'
import { cpf } from 'cpf-cnpj-validator'

export interface IUserClientSchema {
    name: string
    email: string
    cpf: string
}

const userClientSchema: Yup.SchemaOf<IUserClientSchema> = Yup.object()
    .shape({
        name: Yup.string().required('Nome é de usuário obrigatório').max(50, 'Máx 50 caracteres'),
        email: Yup.string().required('E-mail é obrigatório').email('E-mail inválido').max(100, 'Máx 100 caracteres'),
        cpf: Yup.string()
            .test(
                'validateCPF',
                'CPF inválido',
                value => cpf.isValid(value || '')
            )
            .required('CPF é obrigatório')
    })
    .required()

export default userClientSchema